module.exports = __webpack_public_path__ + "static/tulsa-2-53c7190d0e4f8904b7997f075cc4fd31.jpg";